<template lang="pug">
  .component-tabbed-vehicle-reports
    .action-bar
      .title
        h2 Reservations
    .tabs-inner-content
      .row
        .column.small-8
          date-range-picker(@input="dateRangeSelected")
        .column.shrink
        a.fa.fa-search.fa-2x(v-on:click="filterReservation")

      base-list(:component="component", :dataLoader="dataLoader", componentType="vehicle-list" ref="list")
      //paginated-list(:itemComponent="component", :data="items", :type="'vehicle-list'", :perPage="resultsPerpage", @changePage="loadReportings")
</template>
<script type="text/babel">
import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
import ReportingListForm from "../../structure/ui/filters/ReportingListForm";
import BaseList from "../../../pages/backoffice/BaseList";
import DateRangePicker from "../../structure/DateRangePicker";

export default {
  name: "TabbedVehicleReservations",
  components: {
    DateRangePicker,
    BaseList,
    ReportingListForm,
  },
  data() {
    return {
      component: require('components/backoffice/Reservation.vue'),
      search: {
        start: '',
        end: '',
        vehicle_id: this.$route.params.id,
      },

    }
  },
  created() {
  },

  methods: {
    dataLoader(callback, page, resultsPerPage) {

      KeplerBackofficeSdk.vehicles.list(page, resultsPerPage,this.search).movements((data) => {
        callback(data)
      })
    },
    dateRangeSelected(range) {
      if( range.start == "" && range.end == "") {
        this.filterReservation()
      }
      this.search.start = range.start
      this.search.end = range.end
    },
    filterReservation() {
      this.$refs.list.debouncedLoader()
    },
  },

}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleReservations.vue?1a97182c